import HBSelect from "@/components/HBInput/select";
import useAppStore from "@/context/store";
import { updateBoard } from "@/services";
import imageUrl from "@/utils/imageUrl";
import useRequest from "@/utils/useReq";
import { Button } from "antd";
import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import styles from "./index.module.less";

const ICON_MAP = {
  time: <HBIcon type="ic_schedule2" />,
  search: <HBIcon type="ic_search" />,
};
// 用于显示分类选择
const showCategoryMap = {};

export default function PinCreatorBoardCard({
  board,
  cover,
  index,
  activeIndex,
  operationVisible,
  onSelect,
}) {
  const categories = useAppStore((store) => store.categories);
  const [category, setCategory] = useState(board?.category_id);
  const [visible, setVisible] = useState(operationVisible || false);

  const { runAsync: runUpdateBoard } = useRequest(updateBoard, {
    manual: true,
  });

  const onCategoryChange = useCallback(
    async (value) => {
      showCategoryMap[board.board_id] = value;
      setCategory(value);

      const result = await runUpdateBoard({
        board_id: board.board_id,
        category: value,
      });

      if (!result.err) {
        HBMessage.success("画板分类修改成功");
      }
    },
    [board, runUpdateBoard]
  );

  const categoryName = useMemo(() => {
    const categoryId = showCategoryMap[board?.board_id] || category;
    return (
      categories?.find((item) => item.value === categoryId)?.name || "未分类"
    );
  }, [board, categories, category]);

  return (
    <div
      className={classNames([
        styles.item,
        visible ? styles.show : null,
        activeIndex === index ? styles.active : null,
      ])}
      onClick={() => onSelect(board?.board_id)}
      data-index={index}
    >
      <Switch>
        <Case condition={board?._icon}>
          <div className={styles.icon}>
            {ICON_MAP[board?._icon] || board?._icon}
          </div>
        </Case>
        <Case condition={!board}>
          <div className={styles.icon}>{ICON_MAP.time}</div>
        </Case>
      </Switch>
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.img}>
            <If condition={cover}>
              <Then>
                <img
                  src={imageUrl(cover, { width: 32 })}
                  alt={board?.title}
                  loading="lazy"
                />
              </Then>
              <Else>
                <div className={styles.cover}>
                  <HBIcon type="ic_logo" />
                </div>
              </Else>
            </If>
          </div>
          <div className={styles.name}>
            {board ? board?.title : "待归类采集"}
          </div>
          <When
            condition={
              board && board?.is_private !== 0 && board?.is_private !== 1
            }
          >
            <HBIcon
              type="ic_lock"
              className={styles.private}
              title="私有画板"
            />
          </When>
        </div>
        <When condition={board}>
          <div className={styles.right}>
            <span>{categoryName}</span>
            <span className={styles.split}>·</span>
            <span>{board?.pin_count}</span>
          </div>
        </When>
      </div>
      <div className={styles.operation}>
        <When
          condition={
            (!board?.category_id || showCategoryMap[board?.board_id]) && board
          }
        >
          <div
            className={styles.categorySelect}
            data-gd-click="button_click"
            data-button-name="选择画板分类"
            onClick={(evt) => evt.stopPropagation()}
          >
            <HBSelect
              wrapClassName={styles.wrap}
              {...(showCategoryMap[board?.board_id] || category
                ? { value: showCategoryMap[board?.board_id] || category }
                : null)}
              placement="bottomRight"
              placeholder="选择分类"
              optLabel="name"
              dropdownClassName={styles.dropdown}
              options={categories}
              onChange={onCategoryChange}
              onDropdownVisibleChange={(visible) => setVisible(visible)}
              noWrapper={true}
            />
          </div>
        </When>
        <Button
          type="primary"
          data-board-id={board?.board_id}
          data-gd-click="button_click"
          data-button-name="采下来"
        >
          采下来
        </Button>
      </div>
    </div>
  );
}
